import Footer from "../Footer";
import {
  MainLayout,
  MainContent,
  Navbar,
  NavbarInner,
  Brand,
  NavLinks,
  NavLink,
} from "./styles";

interface LayoutProps {
  children?: any;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <MainLayout>
      <Navbar>
        <NavbarInner>
          <Brand to="/" aria-label="Kontra home">
            <img src="/img/icons/CSMainIcon copy4 copy.png" alt="" />
            Kontra
          </Brand>
          <NavLinks>
            <NavLink exact to="/">
              Home
            </NavLink>
            <NavLink to="/HostingServer">Hosting</NavLink>
            <NavLink to="/Subscriptions">Subscriptions</NavLink>
            {/* <NavLink to="/CryptoPayment">Crypto Payment</NavLink> */}
          </NavLinks>
        </NavbarInner>
      </Navbar>
      <MainContent>{children}</MainContent>
      <Footer />
    </MainLayout>
  );
};

export default Layout;
